<template>
    <div v-click-outside="hideResult" @click="showResult">
        <div class="form-group">
            <input type="text"
                   class="input-text"
                   autocomplete="off"
                   placeholder="Search for products..."
                   v-model="query">
            <button class="header-search__btn" @click="search()">
                <span>Search</span>
                <svg class="svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#search"></use></svg>
            </button>
        </div>
        <div class="search-result" v-show="show">
            <div v-for="(item, key) in items"
                 @mouseover="selected = key"
                 class="search-item"
                 @click="goToLink()"
                 v-bind:class="{ 'bg-secondary': selected === key }">
                <p>{{item.title}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'

    export default {
        name: "ProductSearch",
        data() {
            return {
                selected: 0,
                items: [],
                query: '',
                show: false,
            }
        },
        watch: {
            query: function (newVal, oldVal) {
                if (this.items.hasOwnProperty(this.selected) && newVal === this.items[this.selected].title) {
                } else {
                    this.debouncedGetSearchResulrts();
                }
            }
        },
        directives: {
            ClickOutside
        },
        created: function () {
            this.debouncedGetSearchResulrts = _.debounce(this.getData, 500)
        },
        methods: {
            arrowsUpPress() {
                let currentSelected = this.selected - 1;
                if (this.items.hasOwnProperty(currentSelected)) {
                    this.selected = this.selected - 1;
                } else {
                    this.selected = this.items.length - 1;
                }
                this.changeQueryText();
            },
            arrowsDownPress() {
                let currentSelected = this.selected + 1;
                if (this.items.hasOwnProperty(currentSelected)) {
                    this.selected = this.selected + 1;
                } else {
                    this.selected = 0;
                }
                this.changeQueryText();
            },
            changeQueryText() {
                if (this.items.hasOwnProperty(this.selected)) {
                    this.$set(this, 'query', this.items[this.selected].title, false);
                }
            },
            goToLink() {
                location = this.items[this.selected].url;
            },
            hideResult() {
                this.show = false;
            },
            showResult() {
                this.show = true;
            },
            getData() {
                if (!this.query) {
                    this.items = [];
                } else {
                    axios.post('/catalog/autocomplete', {query: this.query}).then(res => {
                        this.items = res.data;
                    }).catch(error => {
                        Sentry.captureException(error);
                    });
                }
            },
            search() {
                location = '/catalog/search?query=' + this.query;
            }
        },
        mounted() {
            document.addEventListener('keydown', (e) => {
                switch (e.key) {
                    case 'ArrowUp':
                        e.preventDefault();
                        this.arrowsUpPress();
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        this.arrowsDownPress();
                        break;
                    case 'Enter':
                        e.preventDefault();
                        this.goToLink();
                        break;
                    default:
                        return;
                }
            });
        }
    }
</script>
